//import { BOCountry } from "./BOCountry.model";

export class BORelativeDisease{
    id:number;
    tempId?:string;
    patientId:number;
    relativeType:string;
    cei10Code:string;
    cei11Code:string;
    cei10Name:string;
    cei11Name:string;
}
